module.exports = __webpack_public_path__ + "media/images/logo_text_pl-cfa59a3b75157b4fcb14968bdb3492cd.svg";